import { webkitLineClamp } from 'webkit-line-clamp';
export class LineClampModule {
	constructor() {
		this.truncateSelector = '.truncate-at-line';
		this.truncateAtLine = 2; // default
		this.breakpointsToTruncateAt = [
			'xs',
			'sm',
			'md',
			'lg',
			'xl',
			'xxl'
		];
		if (typeof document !== 'undefined') {
			this.root = document;
		}
	}
	setRoot(root) {
		this.root = root;
	}

	initialize() {
		if (typeof this.root !== 'undefined') {
			this.lineClamp();
		}
	}
	truncate() {
		let truncatables = this.root.querySelectorAll(this.truncateSelector);
		// console.log('truncatables', truncatables);
		let truncateAtLine = this.truncateAtLine;
		if (truncatables) {
			truncatables.forEach((truncatable) => {
				if (truncatable.dataset && truncatable.dataset.truncateAtLine) {
					truncateAtLine = parseInt(truncatable.dataset.truncateAtLine, 10);
				}
				// console.log('truncateAtLine', truncateAtLine, this.root);
				webkitLineClamp(truncatable, truncateAtLine);
			});
		}
	}
	lineClamp() {
		let currentBreakpoint = window.getComputedStyle(document.documentElement).getPropertyValue('--current-breakpoint');
		if (currentBreakpoint) {
			// console.log('currentBreakpoint', currentBreakpoint);
			this.breakpointsToTruncateAt.forEach(breakpointToTruncateAt => {
				// console.log('breakpointToTruncateAt', breakpointToTruncateAt);
				if (currentBreakpoint === breakpointToTruncateAt) {
					// console.log('root', this.root);
					if (this.root && this.root.querySelectorAll) {
						let truncatables = this.root.querySelectorAll(this.truncateSelector);
						// console.log('truncatables', truncatables);
						let truncateAtLine = this.truncateAtLine;
						if (truncatables) {
							this.truncate();
						}
					} else {
						console.warn('No root found to query from for root', this.root);
					}

				}
			});
		} else {
			// fallback for legacy uses
			this.truncate();
		}
	}


}